// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

// import { HTMLDivProps, IPanelProps, Text } from "@blueprintjs/core";
import { HTMLDivProps, Text } from "@blueprintjs/core";

import * as moment from "moment";

import { IDateFormatProps } from "@blueprintjs/datetime";

import { Classes, MPDButton, MPDHiddenScrollContainer, MPDSelectTypes } from "src/mpd-library/";

import { Redirect, Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertComposeActions, alertListActions } from "src/actions";

import { Select, ToggleButtons,  } from "src/components";

import { Stepper } from "src/controllers/alerts/components";

import Footer from "./footer";

import AlertDetails from "./alert-details/alert-details";
import ChooseAudience from "./choose-audience/choose-audience";
import ComposeMessage from "./compose-message/compose-message";
import PreviewSend from "./preview-send/preview-send";
import SelectChannels from "./select-channels/select-channels";

import "./styles.css";

interface IComposeProps extends HTMLDivProps {
  composeActive?: boolean;
  composePanelStack?: any;
  composeData?: any;
  showBottomToolBar?: boolean;
  loading: boolean;
  isMobileSize: boolean;
  routeProps?: any;
  type?: string;
  onComposeAction: (
    value: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onShowComposeBottomBar: (
    show: boolean
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onUpdateStepper: (
    nav: any,
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onInitializeStepper: (
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onScheduleAlert: (
    scheduledDate: any,
    scheduledTime: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  scheduledDate?: any;
  scheduledTime?: any;
  onToggleRightPanel: () => (dispatch: Dispatch<any>) => Promise<void>;
  onHideCompose: (history: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onSendNowButtonPressed: () => (dispatch: Dispatch<any>) => Promise<void>;
  onUpdateToolBar(topBarProps: any): void;
}

interface IComposeState {
  dateActive: boolean;
  dateFormat: IDateFormatProps;
  timeOptions: Array<string>;
  scheduledDate?: any;
  scheduledTime?: any;
  scrollTop?: number;
  scrolling?: boolean;
}

const FORMAT: IDateFormatProps = {
  formatDate: date => moment(date).format("MMM DD, YYYY"),
  parseDate: str => moment(str, "MMM DD, YYYY").toDate(),
  placeholder: moment(new Date())
    .format("MMM DD, YYYY")
    .toString()
};

class Compose extends React.Component<
  IComposeProps,
  IComposeState
> {

  private scrollRef: React.RefObject<any>;

  constructor(props: IComposeProps) {
    super(props);
    this.onBackButtonPressed = this.onBackButtonPressed.bind(this);
    this.onNextButtonPressed = this.onNextButtonPressed.bind(this);
    this.onSendNowButtonPressed = this.onSendNowButtonPressed.bind(this);
    this.onStepperItemClick = this.onStepperItemClick.bind(this);
    this.onToggleRightPanel = this.onToggleRightPanel.bind(this);
    this.onTimerButtonPressed = this.onTimerButtonPressed.bind(this);
    this.onSetComposeSchedule = this.onSetComposeSchedule.bind(this);
    this.onScheduleDateChanged = this.onScheduleDateChanged.bind(this);
    this.onScheduleTimeChanged = this.onScheduleTimeChanged.bind(this);
    this.onHeaderSelectChange = this.onHeaderSelectChange.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onHideCompose = this.onHideCompose.bind(this);
    const timeOptions = this.createHalfHourIntervals();
    const dateActive = false;

    this.scrollRef = React.createRef();

    const { scheduledTime, scheduledDate } = this.props;

    this.state = {
      dateActive,
      dateFormat: FORMAT,
      scrollTop: 0,
      timeOptions,
      scheduledDate: scheduledDate || new Date(),
      scheduledTime: scheduledTime || "12:00 am"
    };
  }

  public componentDidMount() {
    this.updateToolBar(this.props.isMobileSize);
    const history = this.props.routeProps.history;
    this.props.onInitializeStepper(history);
    history.listen((location: any, action: any) => {
      if (!this.props.loading) {
        this.props.onInitializeStepper(history);
      }
    });
  }

  public componentWillReceiveProps(nextProps: IComposeProps) {
    if(nextProps.isMobileSize !== this.props.isMobileSize){
      this.updateToolBar(nextProps.isMobileSize);
    }
  }

  public render() {
    const { className, composeData, loading, routeProps } = this.props;
    const { scrollTop } = this.state;
    const { showHints, stepper, type } = composeData;

    const pathname = routeProps.history.location.pathname;
    const pathnameArr = pathname.split('/');
    const showBottomBar =
      !pathname.includes("group") && !pathname.includes("geofence") && !pathname.includes('incident-location');

    const {
      dateFormat,
      dateActive,
      timeOptions,
      scheduledDate,
      scheduledTime,
      scrolling
    } = this.state;

    const classes = classNames(
      myClasses.ALERTS_CONTENT_COMPOSE_CONTAINER,
      loading && Classes.LOADING,
      className
    );

    return (
      <div className={classes}>
        <Stepper
          loading={loading}
          className={myClasses.ALERTS_CONTENT_COMPOSE_HEADER}
          data={stepper.data}
          onItemClick={this.onStepperItemClick}
        />
        <MPDHiddenScrollContainer
          yDirection={true}
          onScroll={this.onScroll}
          scrollRef={this.scrollRef}
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_CONTENT_CONTAINER,
            pathnameArr[pathnameArr.length - 1],
            loading && Classes.LOADING
          )}
        >
          <div
            className={myClasses.ALERTS_CONTENT_COMPOSE_CONTENT_INNER_CONTAINER}
          >
            <Switch>
              <Route
                exact={true}
                path="/alerts/compose"
                render={() => <Redirect to="/alerts/compose/choose-audience" />}
              />
              <Route
                path={"/alerts/compose/choose-audience"}
                render={() => (
                  <ChooseAudience
                    routeProps={routeProps}
                    {...this.props as any}
                  />
                )}
              />
              <Route
                path={"/alerts/compose/select-channels"}
                render={() => (
                  <SelectChannels
                    routeProps={routeProps}
                    {...this.props as any}
                  />
                )}
              />
              <Route
                path={"/alerts/compose/alert-details"}
                render={() => (
                  <AlertDetails
                    routeProps={routeProps}
                    type={type}
                    {...this.props as any}
                  />
                )}
              />
              <Route
                path={"/alerts/compose/compose-message"}
                render={() => (
                  <ComposeMessage
                    routeProps={routeProps}
                    {...this.props as any}
                    showHints={showHints}
                  />
                )}
              />
              <Route
                path={"/alerts/compose/preview-send"}
                render={() => (
                  <PreviewSend scrolling={scrolling} scrollTop={scrollTop} routeProps={routeProps} {...this.props as any} />
                )}
              />
            </Switch>
          </div>
        </MPDHiddenScrollContainer>
        <div />
        {showBottomBar && (
          <Footer
            loading={loading}
            onTimeChange={this.onScheduleTimeChanged}
            onDateChange={this.onScheduleDateChanged}
            onSetScheduleButtonPressed={this.onSetComposeSchedule}
            dateFormat={dateFormat}
            scheduledDate={scheduledDate}
            scheduledTime={scheduledTime}
            timeOptions={timeOptions}
            dateActive={dateActive}
            step={stepper.step}
            onTimerButtonPressed={this.onTimerButtonPressed}
            onSendNowButtonPressed={this.onSendNowButtonPressed}
            onNextButtonPressed={this.onNextButtonPressed}
            onBackButtonPressed={this.onBackButtonPressed}
          />
        )}
      </div>
    );
  }

  private onScroll(event: any){
    if(this.scrollRef.current){
      const scrollTop = this.scrollRef.current.scrollTop;
      this.setState({ scrolling: true, scrollTop });
      setTimeout(() => {
        if(this.state.scrolling && this.state.scrollTop === scrollTop) {
          this.setState({ scrolling: false });
        }
      }, 200);
    }
  }

  private updateToolBar(isMobileSize: boolean) {
    const topBarProps = {
      leftElement: (
        <ToggleButtons
          label="Compose"
          hideExitButton={true}
          onToggle={this.onToggleRightPanel}
        />
      ),
      rightElement: (
        <div className="compose-tools-container">
          <Select
            className="options-select"
            label="Options"
            selectable={false}
            type={MPDSelectTypes.staticText}
            options={["Save as draft", "Delete"]}
            arrowName="drop-down"
            onChange={this.onHeaderSelectChange}
          />
          <MPDButton
            name="compose-view--header--exit-transparent"
            onClick={this.onHideCompose}
          />
        </div>
      )
    };

    const mobileTopBarProps = {
      leftElement: (
        <MPDButton
            name="compose-view--header--exit-transparent"
            onClick={this.onHideCompose}
          />
      ),
      centerElement: (
        <Text className='label'> Compose </Text>
      )
    }
    isMobileSize ?  this.props.onUpdateToolBar(mobileTopBarProps) :  this.props.onUpdateToolBar(topBarProps);
  }

  private onHideCompose(event?: React.MouseEvent<any>) {
    const { routeProps } = this.props;
    this.props.onHideCompose(routeProps.history);
  }

  private onHeaderSelectChange(event: any) {
    this.props.onComposeAction(event.currentTarget.textContent);
  }

  private onToggleRightPanel(event?: React.MouseEvent<any>) {
    this.props.onToggleRightPanel();
  }

  private onScheduleTimeChanged(event: any) {
    const scheduledTime = event.currentTarget.textContent;
    this.setState({ scheduledTime });
  }

  private onScheduleDateChanged(selectedDate: Date, isUserChange: boolean) {
    this.setState({ scheduledDate: selectedDate });
  }

  private onSetComposeSchedule() {
    const { scheduledTime } = this.state;
    let { scheduledDate } = this.state;
    scheduledDate = moment(scheduledDate).format("MM/DD/YY");
    this.props.onScheduleAlert(scheduledDate, scheduledTime);
    this.setState({ dateActive: false });
  }

  private createHalfHourIntervals() {
    const startDate = moment().startOf("day");
    const dates = [];
    const hourDivider = 2;
    let t = hourDivider * 24;
    while (t--) {
      dates.push(startDate.format("hh:mm A"));
      startDate.add(60 / hourDivider, "minute");
    }
    return dates;
  }

  private onTimerButtonPressed(event: any, status: boolean) {
    const dateActive = status;
    this.setState({ dateActive });
  }

  private onStepperItemClick(event: any, index: number) {
    const nav = this.props.composeData.stepper.data[index].nav;
    this.props.onUpdateStepper(nav, this.props.routeProps.history);
  }

  private onBackButtonPressed() {
    const stepper = this.props.composeData.stepper;
    const step = stepper.step;
    const nav = this.props.composeData.stepper.data[Math.max(step - 1, 0)].nav;
    this.props.onUpdateStepper(nav, this.props.routeProps.history);
  }

  private onNextButtonPressed() {
    const stepper = this.props.composeData.stepper;
    const step = stepper.step;
    const nav = this.props.composeData.stepper.data[
      Math.min(step + 1, stepper.data.length - 1)
    ].nav;
    this.props.onUpdateStepper(nav, this.props.routeProps.history);
  }

  private onSendNowButtonPressed(event: any) {
    this.props.onSendNowButtonPressed();
  }
}

const mapStateToProps = (state: any) => {
  const { alerts, global } = state;
  const { isMobileSize } = global;

  const {
    composeActive,
    composeData,
    composePanelStack,
    composeTopBarProps,
    composeBottomBarProps
  } = alerts;
  const { loading, scheduledTime } = composeData;

  let { scheduledDate } = composeData;

  if (scheduledDate) {
    scheduledDate = moment(scheduledDate, "MM/DD/YY").toDate();
  }

  return {
    loading,
    composeTopBarProps,
    composeBottomBarProps,
    composeActive,
    composePanelStack,
    isMobileSize,
    scheduledDate,
    scheduledTime,
    composeData
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onToggleRightPanel: bindActionCreators(
      alertListActions.onToggleRightPanel,
      dispatch
    ),
    onUpdateStepper: bindActionCreators(
      alertComposeActions.onUpdateStepper,
      dispatch
    ),
    onInitializeStepper: bindActionCreators(
      alertComposeActions.onInitializeStepper,
      dispatch
    ),
    onSendNowButtonPressed: bindActionCreators(
      alertComposeActions.onPreviewSendToggleLaunch,
      dispatch
    ),
    onScheduleAlert: bindActionCreators(
      alertComposeActions.onScheduleAlert,
      dispatch
    ),
    onComposeAction: bindActionCreators(
      alertComposeActions.onComposeAction,
      dispatch
    ),
    onShowComposeBottomBar: bindActionCreators(
      alertComposeActions.onShowComposeBottomBar,
      dispatch
    ),
    onHideCompose: bindActionCreators(alertListActions.onHideCompose, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Compose);



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/compose.tsx